var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useContext, useEffect, useMemo } from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Footer, Header, PageBanner } from "@sequentech/ui-essentials";
import { getValueFromCookie, setCookie, USER_LANGUAGE_COOKIE_NAME } from "@sequentech/ui-core";
import { useTranslation } from "react-i18next";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { useCustomCss } from "@/providers/CustomCssContextProvider";
import { useResultsManifest } from "@/providers/ResultsManifestContextProvider";
import { useResultsAuth } from "@/providers/ResultsAuthContextProvider";
import { CustomCssStylesheet } from "@/components/CustomCssStylesheet";
var StyledApp = styled(Stack)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-height: 100vh;\n"], ["\n    min-height: 100vh;\n"])));
var StyledMain = styled(PageBanner)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex: 1;\n    align-items: stretch;\n    background: #f7f8fa;\n"], ["\n    flex: 1;\n    align-items: stretch;\n    background: #f7f8fa;\n"])));
var AppHeader = function () {
    var globalSettings = useContext(SettingsContext).globalSettings;
    var i18n = useTranslation().i18n;
    var _a = useResultsManifest(), availableLanguages = _a.availableLanguages, defaultLocale = _a.defaultLocale;
    var _b = useResultsAuth(), isAuthenticated = _b.isAuthenticated, userProfile = _b.userProfile, logout = _b.logout;
    var languagesList = useMemo(function () { return (availableLanguages.length > 0 ? availableLanguages : ["en"]); }, [availableLanguages]);
    var languagesKey = languagesList.join("|");
    useEffect(function () {
        var _a, _b;
        var currentLanguage = (_a = i18n.resolvedLanguage) !== null && _a !== void 0 ? _a : i18n.language;
        if (languagesList.includes(currentLanguage)) {
            return;
        }
        var fallbackLanguage = languagesList.includes(defaultLocale)
            ? defaultLocale
            : ((_b = languagesList[0]) !== null && _b !== void 0 ? _b : "en");
        void i18n.changeLanguage(fallbackLanguage);
        if (getValueFromCookie(USER_LANGUAGE_COOKIE_NAME) !== fallbackLanguage) {
            setCookie(USER_LANGUAGE_COOKIE_NAME, fallbackLanguage);
        }
    }, [defaultLocale, i18n, languagesKey, languagesList]);
    var onChangeLanguage = function (lang) {
        if (getValueFromCookie(USER_LANGUAGE_COOKIE_NAME) !== lang) {
            setCookie(USER_LANGUAGE_COOKIE_NAME, lang);
        }
    };
    return (_jsx(Box, { className: "seq-results-portal-header", children: _jsx(Header, { appVersion: { main: globalSettings.APP_VERSION }, appHash: { main: globalSettings.APP_HASH }, userProfile: isAuthenticated ? userProfile : undefined, logoutFn: isAuthenticated ? logout : undefined, logoUrl: "/Sequent_logo_small.png", logoLink: "https://sequentech.io", languagesList: languagesList, onChangeLanguage: onChangeLanguage }) }));
};
export var App = function () {
    var customCss = useCustomCss().customCss;
    return (_jsxs(_Fragment, { children: [_jsx(CustomCssStylesheet, { css: customCss }), _jsxs(StyledApp, { className: "seq-results-portal-app app-root", children: [_jsx(ScrollRestoration, {}), _jsx(AppHeader, {}), _jsx(StyledMain, { className: "seq-results-portal-main", id: "main-content", role: "main", children: _jsx(Box, { className: "seq-results-portal-main__content", sx: { width: "100%" }, children: _jsx(Outlet, {}) }) }), _jsx(Box, { className: "seq-results-portal-footer", children: _jsx(Footer, {}) })] })] }));
};
var templateObject_1, templateObject_2;
